import { useCallback, useEffect, useMemo, useState } from 'react';
import I18n from 'I18n';
import UISearchInput from 'UIComponents/input/UISearchInput';
import debounce from 'react-utils/debounce';
import usePrevious from 'react-utils/hooks/usePrevious';
import Categories from 'ContentUtils/constants/Categories';
import { jsx as _jsx } from "react/jsx-runtime";
const SEARCH_DEBOUNCE_MS = 500;
const getPlaceholderTextKey = contentTypeId => {
  switch (contentTypeId) {
    case Categories.blog_post.id:
      return 'contentManagementPanel.table.searchInput.blog';
    case Categories.site_page.id:
      return 'contentManagementPanel.table.searchInput.sitePages';
    case Categories.landing_page.id:
      return 'contentManagementPanel.table.searchInput.landingPages';
    default:
      return 'contentManagementPanel.table.searchInput.default';
  }
};
const ContentSearchInput = ({
  contentTypeId,
  search,
  updateSearch
}) => {
  const [searchQuery, setSearchQuery] = useState(search || '');
  const prevContentTypeId = usePrevious(contentTypeId);
  const placeholderTextKey = getPlaceholderTextKey(contentTypeId);
  useEffect(() => {
    if (contentTypeId && contentTypeId !== prevContentTypeId && searchQuery !== search) {
      setSearchQuery(search || '');
    }
  }, [contentTypeId, prevContentTypeId, searchQuery, search]);
  const handleUpdateSearchDebounced = useMemo(() => debounce(updatedSearchQuery => {
    updateSearch(updatedSearchQuery);
  }, SEARCH_DEBOUNCE_MS), [updateSearch]);
  const handleSearchChange = useCallback(event => {
    const newSearchQuery = event.target.value;
    setSearchQuery(newSearchQuery);
    handleUpdateSearchDebounced(newSearchQuery);
  }, [handleUpdateSearchDebounced]);
  return /*#__PURE__*/_jsx(UISearchInput, {
    onChange: handleSearchChange,
    className: "m-y-4",
    placeholder: I18n.text(placeholderTextKey),
    value: searchQuery,
    "data-test-id": "search-input"
  });
};
export default ContentSearchInput;